import {
  EconomicsResponseInput,
  economicsResponseInputSchema,
  financialEvents,
} from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useInfiniteQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const US_COUNTRY_CODE = 'US';

const QUERY_KEY_ECONOMICS_EVENTS = 'QUERY_KEY_ECONOMICS_EVENTS';
const PAGE_SIZE = 20;

export interface UseEconomicsEventsProps {
  from: string;
  to: string;
  countries?: string[];
  categories?: string[];
  pageSize?: number;
  sortBy?: string;
  sortDesc?: boolean;
}

export const useEconomicsEvents = ({
  from,
  to,
  countries,
  categories,
  pageSize = PAGE_SIZE,
  sortBy,
  sortDesc,
}: UseEconomicsEventsProps) =>
  useInfiniteQuery({
    enabled: !!from && !!to,
    queryKey: [
      QUERY_KEY_ECONOMICS_EVENTS,
      to,
      from,
      countries,
      categories,
      pageSize,
      sortBy,
      sortDesc,
    ],
    queryFn: async ({ signal, pageParam }) => {
      const { path, schema } = financialEvents.getEconomics;
      const url = path({
        from,
        to,
        countries,
        categories,
        page: pageParam,
        pageSize,
        sortBy,
        sortDesc,
      });

      const response = await wretchRequest<EconomicsResponseInput>(url, {
        schema,
        signal,
      });

      return economicsResponseInputSchema.parse(response).economics;
    },
    initialPageParam: 1,
    staleTime: getTimeTillEndOfDayMs(),
    getNextPageParam: (lastPage, _, lastPageParam) => {
      if (lastPage.length === 0) {
        return undefined;
      } else if (lastPage.length === pageSize) {
        return lastPageParam + 1;
      } else {
        return undefined;
      }
    },
  });
